





helpers = require('../../../helpers.coffee')

view_model = {
  data: ->
    current_company: Session.current_company

  components:
    alertTick: require('./alert_tick')

  computed:
    css_class: ->
      if !Session.current_user.plivo_endpoint || Session.current_company.isVoipExceeded() || !Session.current_company.isPlivo()
        "inactive"
      else
        ""
        
    voip_status: ->
      @current_company.voip_plan_status

    voip_message: ->
      switch @voip_status
        when 'exceeded' then 'Sua franquia mensal do VoIP se esgotou'
        when 'exceeding' then 'Sua franquia mensal do VoIP está próxima do fim'
        when 'additional_time' then 'Sua franquia mensal do VoIP se esgotou e estará consumindo seus minutos adicionais'
        else ''

  methods:
    subscribeToVoipUsageChannel: ->
      @removeVoipSubscription()
      @voip_subscription = ActionCable.cable.subscriptions.create { channel: 'PlivoPlanUsageChannel', company_id: @current_company.id },
        received: (event_data) =>
          Session.current_company.voip_plan_status = event_data
          @$emit 'update-company'
          setTimeout(Tooltip.initialize, 1000)

    removeVoipSubscription: ->
      ActionCable.cable.subscriptions.remove(@voip_subscription) if @voip_subscription
      @voip_subscription = null

    openDialer: (number, number_type, task, open_comment = false) ->
      event.originalEventName = 'open-dialer'
      data = { contact: task?.contact, task: task, number: number, number_type: number_type, open_comment: open_comment  }
      EventsBus.$emit 'open-dialer', data

  created: ->
    @voip_subscription = null
    @subscribeToVoipUsageChannel()

  beforeDestroy: ->
    @removeVoipSubscription()
}


exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/header_actions/voip.vue